import { Map } from 'immutable'
import { pick } from 'ramda'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'

const integration = handleActions({
  [combineActions(
    actions.patchGoogleAnalyticsPending,
    actions.getGoogleAnalyticsSettingsPending
  )]: (state) => state.set('updatePending', true),

  [combineActions(
    actions.patchGoogleAnalyticsFailed,
    actions.patchGoogleAnalyticsSuccess,
    actions.getGoogleAnalyticsSettingsFailed,
    actions.getGoogleAnalyticsSettingsSuccess
  )]: (state) => state.set('updatePending', false),

  [actions.getGoogleAnalyticsSettingsSuccess]:
    (state) => state.get('settingsLoaded') ? state : state.set('settingsLoaded', true),

  [combineActions(
    actions.getGoogleAnalyticsSettingsSuccess,
    actions.patchGoogleAnalyticsSuccess
  )]: (state, action) => (
    state.merge(pick([
      'enabledEventMappings',
      'individualEventsEnabled',
      'trackingName'
    ], action.payload))
  )
}, Map({ settingsLoaded: false }))

export default combineReducers({ integration })


// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/reducer.js